module.exports = __webpack_public_path__ + "static/media/ALTHAR_LOGO_CLARO_TEXTO-05.e8ba09c7.svg";